import React from 'react';
import FacebookLogin from 'react-facebook-login';
// import GitHubLogin from 'react-github-login';
import './Login.css'
import { Redirect } from 'react-router';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import GTranslateIcon from '@material-ui/icons/GTranslate';
import GitHubIcon from '@material-ui/icons/GitHub';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import axios from 'axios';

import md5 from 'md5';

import {
  Link
} from "react-router-dom";

class Login extends React.Component{
    constructor(props){
            super(props);

            this.state = {
                email:'',
                password:"",
                isTrueLogin: false,
                accessToken:"",
                resToken:"",
                id:"",
                name:"",
                picture:"",
                onFb:false,
                offFb:false,
                onLink:""
            }         
            this.onSubmit = this.onSubmit.bind(this);           

        }




    onSubmit(e){
        e.preventDefault();
        var {email, password} = this.state;
        document.cookie = `${md5(email)}`
        document.cookie = `${md5(password)}`
        var cookie = document.cookie
        if(cookie === "0fe8cf3262d72131ec5d304cd3d8190b"){
            this.setState({isTrueLogin : true})
        }
        // this.setState({redirect : 200})
        // var username = getCookie("username");
  
    }

    onLink=()=>{
        axios.get(`https://graph.facebook.com/v6.0/oauth/access_token?grant_type=fb_exchange_token&client_id=313201206487594&client_secret=effb6a36ca65a95878321869bc67c492&fb_exchange_token=${this.state.accessToken}`).then(res =>{
            if(res.status == 200){
                this.setState({resToken:res.data.access_token, onLink:"onLink"})
            }
        })
    }

    responseFacebook = (res) => {
        if(res.name === null){
            console.log("null")
        }else{
            console.log(res)
            sessionStorage.setItem("accessToken", res.accessToken)
            sessionStorage.setItem("name", res.name)
            sessionStorage.setItem("id", res.id)
            sessionStorage.setItem("picture", res.picture.data.url)
            this.setState({onFb:true,accessToken:res.accessToken, name:res.name, id:res.id, picture:res.picture.data.url})
            

        }
     
    }






    render(){
    
        const {id, name, picture, accessToken, onFb, offFb, onLink, resToken} = this.state;
        var accessTokens = sessionStorage.getItem('accessToken');
        var names = sessionStorage.getItem('name');
        var ids = sessionStorage.getItem('id');
        var pictures = sessionStorage.getItem('picture');

        if(onFb === true){
            setTimeout(()=>{ this.setState({offFb:true}) }, 2000)
        }
        

        return(
            <div className="container-fluid" style={{background:"#e4eef6"}}>
                    <div className="row">
                        <div className="col-12 col-sm-12 col-lg-12 col-xl-12">
                            <div className="ui_mobi">
                                <div class="header">
                                    <div class="discover">Login</div>
                                    <div class="menu-line">---</div>
                                </div>
                                    
                                    {
                                        offFb === true ? 
                                        <div className="conten">
                                            <img src={pictures} />
                                            <p>ID: {ids}</p>
                                            <p>{names}</p>
                                            <br/>
                                            <br/>
                                            <br/>
                                            <br/>
                                            <button style={{borderRight: "inset"}} id={onLink} onClick={this.onLink}>Check Token</button>
                                            <br/>
                                            <br/>
                                            <span>Token:</span><input style={{border:"none"}} value={resToken}/>
                                        </div>

                                        :

                                        <div className="login_user" style={{top:onFb === true ? "15%" : ""}}>
                                
                                            <FacebookLogin
                                                appId="313201206487594"
                                                autoLoad={true}
                                                fields="name,email,picture"
                                                callback={this.responseFacebook}
                                                cssClass="my-facebook-button-class"
                                                icon="fa-facebook"
                                              />
                                        </div>
                                    }
                                    
                      
                                
                                <div class="nav">
                                    <div class="nav-first">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-home" viewBox="0 0 24 24">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path>
                                        </svg>
                                        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="css-i6dzq1" viewBox="0 0 24 24">
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <path d="M21 21l-4.35-4.35"></path>
                                        </svg>
                                        <svg style={{width: "15px", height: "15px"}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29">
                                        <g fill="#FFF" fill-rule="evenodd" stroke="currentColor" stroke-width="3">
                                        <rect width="21" height="21" x="7" y="7" rx="5"></rect>
                                        <rect width="21" height="21" x="1" y="1" rx="5"></rect>
                                        </g>
                                        </svg>
                                        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="css-i6dzq1" viewBox="0 0 24 24">
                                        <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"></path>
                                        </svg>
                                    </div>
                                    </div>
                            </div>
                        </div>
                    </div>
            </div>
        )
    }
}

export default Login;

